export default __webpack_public_path__ + "static/posterMaraGladiator-24e56d362b5a139fec6d000dd66146d8.svg";